import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'sentToIdentifyComment'
})
export class SentToIdentifyCommentPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(commentType: string, corporateAccountName?: string, isMyMessage?: boolean, posted_by?: string): string {
    const commentTypesTranslations = {
      collaborator: `${isMyMessage ? 'COMMENT_TO_COLLABORATORS' : posted_by === 'company' ? 'COMMENT_TO_CORPORATE_BY_COLLABORATOR' : 'COMMENT_TO_COLLABORATORS'}`,
      company: `${isMyMessage ? 'COMMENT_TO_MANAGER' : 'COMMENT_TO_CORPORATE_BY_MANAGER'}`,
      corporate: 'COMMENT_TO_CORPORATE',
      internal: 'COMMENT_TO_INTERNAL',
      public: 'COMMENT_TO_PUBLIC',
    };
    const translatedCommentType = `MAINTENANCES.TABS.COMMENTS.${commentTypesTranslations[commentType]}`;
    return this.translateService.instant(translatedCommentType, {
      corporateAccountName
    });
  }
}
